export const ETipoEstoque = {
  Estoque: 0,
  Futuro: 1,
  Vendas: 2,
};

/**
 * Enum table itens
 */
export const ETableItens = {
  hoje: 0,
  maisUm: 1,
  maisDois: 2,
  maisTres: 3,
  maisQuatro: 4,
  maisCinco: 5,
  maisSeis: 6,
  maisQuinze: 7,
  maisTrinta: 8,
  maisSessenta: 9,
  maisNoventa: 10,
};

export const ETableHaders = {
  mensuracao: 0,
  hoje: 1,
  maisUm: 2,
  maisDois: 3,
  maisTres: 4,
  maisQuatro: 5,
  maisCinco: 6,
  maisSeis: 7,
  maisQuinze: 8,
  maisTrinta: 9,
  maisSessenta: 10,
  maisNoventa: 11,
};

export const ISO4217 = {
  'DOLAR DOS EUA': 'USD',
  'EURO/COM.EUROPEIA': 'EUR',
  'FRANCO SUICO': 'CHF',
  'COROA SUECA': 'SEK',
  'REAL/BRASIL': 'BRL',
  'BALBOA/PANAMA': 'PAB',
  'WON COREIA SUL': 'KRW',
};
